import axios from 'axios';

export class SubCategoriesService {
    async fetchAllSubCategories() {
        return (await axios.get('/subcategory/filter?status=Active')).data;
    }
}